import React from "react";
import {bemNames} from "../../utils/bemnames";
import {IProvider} from "../../utils/types";
import {baseSportsIndexDomain} from "../../utils/request";
import {useGlobalState} from "../../contexts/GlobalState";
import ImgWithDefault from "../ImgWithDefault";

const bem = bemNames.create('odds');

interface IProps {
  odds: string | null;
  direction: 'up' | 'down' | null;
  arrow?: boolean;
  provider?: IProvider;
}

const Odds: React.FC<IProps> = ({odds, direction, arrow = true, provider}) => {
  const {globalState} = useGlobalState()
  const getStyle = (odds: string | null) => {
    let style = {};
    if (odds === null && globalState.promotedProvider !== null) {
      if (globalState.promotedProvider.provider.themeColor !== null && globalState.promotedProvider.provider.themeColor !== undefined)
        Object.assign(style, {backgroundColor: globalState.promotedProvider.provider.themeColor});
    }
    return style;
  }

  return (
    <div
      className={bem.e(`odds-wrapper ${arrow === false ? (direction ?? 'promoted-provider') : ''}`)}
      style={getStyle(odds)}
    >
      {odds !== null ? (
        <React.Fragment>
          <span>{odds}</span>
          {arrow && (
            <div className={bem.e(`triangle ${direction}`)}></div>
          )}
        </React.Fragment>
      ) : globalState.promotedProvider !== null && (
        <ImgWithDefault
          className={bem.e('odds-button-icon')}
          src={`${baseSportsIndexDomain}${globalState.promotedProvider.provider.lightLogoUrl}`}
          style={getStyle(odds)}
          alt={globalState.promotedProvider.provider.name}
        />
      )}
    </div>
  );
}

export default Odds;
